/**
 * Utility class for handling mobile deep linking across the application.
 * This ensures that when a user clicks a button on a mobile device,
 * it attempts to open the native Android app via an Intent URL.
 * If the app is not installed, it gracefully falls back to the Google Play Store.
 */
export class DeepLinkUtil {
  static isAndroid(): boolean {
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      return /Android/i.test(navigator.userAgent);
    }
    return false;
  }

  static getAndroidIntentUrl(path: string): string {
    // Dynamically retrieve the current host (e.g. mm-stage-b2c.acelucid.com or www.beexpert.ai)
    // This allows the deep link to adapt to local, staging, and production environments automatically.
    const domain = typeof window !== 'undefined' ? window.location.host : 'mm-stage-b2c.acelucid.com';
    const pkg = 'com.acelucid.mind_mentor_pro';
    
    // URL-encoded Google Play Store link
    const fallbackUrl = encodeURIComponent(`https://play.google.com/store/apps/details?id=${pkg}`);
    
    // Strip leading slash if it exists to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    
    return `intent://${domain}/${cleanPath}#Intent;scheme=https;package=${pkg};S.browser_fallback_url=${fallbackUrl};end`;
  }
}
